import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/global.css';

import { AuthProvider } from './auth/AuthContext';
import ProtectedRoute from './auth/ProtectedRoute';
import ForgemarkSignIn from './pages/ForgemarkSignIn';
import GameLibrary from './pages/GameLibrary';
import LandingPage from './pages/LandingPage';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Forgemark sign-in (root). Redirects to /games once signed in. */}
          <Route path="/" element={<ForgemarkSignIn />} />

          {/* Game library — requires a signed-in user */}
          <Route
            path="/games"
            element={<ProtectedRoute><GameLibrary /></ProtectedRoute>}
          />

          {/* Pool of Radiance — landing splash, also gated */}
          <Route
            path="/games/pool-of-radiance"
            element={<ProtectedRoute><LandingPage /></ProtectedRoute>}
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
